import { booleanAttribute } from "#ce/utils/props";

export const typeOptions = [
  "display",
  "h1",
  "h2",
  "h3",
  "h4",
  "title",
  "subtitle",
  "body",
  "body-semi-bold",
  "body-bold",
  "link",
  "small",
  "small-bold",
  "footnote",
  "footnote-medium",
  "footnote-bold",
  "label",
  "custom",
  "inherit",
];

export const props = Object.freeze({
  /**
   * Keep the regular typescale on small screens.
   *
   * @type {Boolean|String}
   * @default false
   */
  noSmallScreenType: booleanAttribute(),
  /**
   * Typography token name driving font, weight, size, and line-height. Picks one of the design-system typescale presets — display, h1–h4, title, subtitle, body (regular/semi-bold/bold), link, small, footnote (regular/medium/bold), label — `custom` for the consumer-driven escape hatch fed by --sp-comp-text-custom-font-short, or `inherit` to take font and colour from the surrounding text, as a native heading styled with `font: inherit` does. With `inherit`, `color` still overrides the colour.
   *
   * @type {String}
   * @default undefined
   * @storybook-control select
   */
  type: {
    type: String,
    default: undefined,
    validator: (value) => typeOptions.includes(value),
  },
  /**
   * Rendered HTML tag. Defaults to `<div>`. When the tag matches a typescale name (e.g. "h1") and no explicit `type` is set, the matching typescale is applied automatically.
   *
   * @type {String}
   * @default "div"
   */
  tag: {
    type: String,
    default: "div",
  },
  /**
   * Link target, for a `tag="a"` text.
   *
   * @type {String}
   * @default undefined
   */
  href: {
    type: String,
    default: undefined,
  },
  /**
   * Override the default text colour. Any valid CSS colour value.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
});
